import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Nav from "@/components/vlyt/Nav";
import Footer from "@/components/vlyt/Footer";
import InstallBanner from "@/components/vlyt/InstallBanner";
import { Toaster } from "@/components/ui/sonner";
import { useTheme } from "@/components/vlyt/ThemeProvider";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Founder from "@/pages/Founder";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AppInstall from "@/pages/AppInstall";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

export default function App() {
  const { theme } = useTheme();
  return (
    <div className="App bg-base text-[color:var(--vlyt-text)] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/miesindou" element={<Founder />} />
            <Route path="/support" element={<Support variant="riders" />} />
            <Route path="/support/riders" element={<Support variant="riders" />} />
            <Route path="/support/drivers" element={<Support variant="drivers" />} />
            <Route path="/support/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/app" element={<AppInstall />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <InstallBanner />
        <Toaster theme={theme} position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}
